// features/public-filters/presentation/sections/homeType/HomeTypeDropdown.tsx
import React, { useState } from 'react';
import { HomeType } from '../../../../domain/FilterTypes';
import { HomeTypeBody } from './HomeTypeBody';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { useFilterController } from '../../../../application/useFilterController';

export const HomeTypeDropdown: React.FC = () => {
  const { filter, setHomeTypes } = useFilterController();

  const [ open, setOpen ] = useState(false);
  const dropdownRef = useClickOutside<HTMLDivElement>(() => setOpen(false));

  const selectedTypes = filter.homeTypes || [];

  const handleToggle = (homeType: HomeType) => {
    const newTypes = selectedTypes.includes(homeType)
      ? selectedTypes.filter(type => type !== homeType)
      : [ ...selectedTypes, homeType ];

    setHomeTypes(newTypes); // instant apply to store
  };

  const resetValues = () => {
    setHomeTypes([]); // clears in store; body will reflect it
  };

  const displayLabel =
    selectedTypes.length > 0
      ? `${selectedTypes.length} selected`
      : 'Home type';

  return (
    <div id="home-type-dropdown" className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen(prev => !prev)}
        className="border rounded px-3 py-2 bg-white text-gray-800 flex items-center justify-between min-w-[120px]"
      >
        <span className="text-sm">{displayLabel}</span>
        <svg
          className="ml-2 h-4 w-4 text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-96 bg-white border rounded shadow-lg z-10 p-4">
          <HomeTypeBody
            selectedTypes={selectedTypes}
            onToggle={handleToggle}
          />
          <div className="flex justify-between mt-4">
            <button
              onClick={resetValues}
              className="text-blue-600 text-sm font-medium hover:underline"
            >
              Reset
            </button>
            {/* No Apply button — changes are live */}
          </div>
        </div>
      )}
    </div>
  );
};
